// Add any custom time parsing formats here
export const TimeParsers = {
  simple: 'HHmm',
}

// Add any commonly used time formats here
export const TimeFormats = {
  simple: 'h:mma',
}
